import DefaultProgressDetailsReport from "src/components/feature/progressReport";

const ProgressDetailsReport = () => {
  return <DefaultProgressDetailsReport />;
};

export default ProgressDetailsReport;
